import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "perform_cookie_prefs";
export const readPrefs = () => { try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; } };
export const openCookieSettings = () => window.dispatchEvent(new CustomEvent("perform:cookies"));

const CATEGORIES = [
  { key: "necessary", label: "Strictement nécessaires", text: "Maintien de la session et mémorisation de ce choix. Indispensables au fonctionnement.", locked: true },
  { key: "preferences", label: "Préférences", text: "Mémorise vos réglages d'affichage, comme la liste de prise en main repliée." },
  { key: "analytics", label: "Mesure d'audience", text: "Aucun outil de mesure n'est installé à ce jour. Ce choix s'appliquera si nous en ajoutons un." },
  { key: "marketing", label: "Marketing", text: "Aucun traceur publicitaire n'est installé, et nous n'en prévoyons pas." },
];

export default function CookieBanner() {
  const [open, setOpen] = useState(false);
  const [manage, setManage] = useState(false);
  const [choice, setChoice] = useState({ preferences: true, analytics: false, marketing: false });

  useEffect(() => {
    const saved = readPrefs();
    if (!saved) setOpen(true);
    else setChoice(c => ({ ...c, ...saved }));
    const reopen = () => { setOpen(true); setManage(true); };
    window.addEventListener("perform:cookies", reopen);
    return () => window.removeEventListener("perform:cookies", reopen);
  }, []);

  const save = prefs => {
    localStorage.setItem(KEY, JSON.stringify({ ...prefs, savedAt: new Date().toISOString() }));
    setChoice(c => ({ ...c, ...prefs }));
    setOpen(false); setManage(false);
  };

  if (!open) return null;

  return (
    <div className="cookie" role="dialog" aria-modal="false" aria-label="Préférences de cookies" data-testid="cookie-banner">
      <div className="cookie-inner">
        <div className="cookie-icon"><Cookie size={17} /></div>
        <div className="cookie-body">
          <strong>Cookies</strong>
          <p>
            Nous déposons uniquement les cookies nécessaires au fonctionnement du service.
            Aucun traceur publicitaire. Détail sur la <Link to="/legal/cookies">politique de cookies</Link>.
          </p>

          {manage && (
            <div className="cookie-cats">
              {CATEGORIES.map(c => (
                <label key={c.key} className={c.locked ? "is-locked" : undefined}>
                  <input
                    type="checkbox" data-testid={`cookie-${c.key}`}
                    checked={c.locked ? true : !!choice[c.key]} disabled={c.locked}
                    onChange={e => setChoice(prev => ({ ...prev, [c.key]: e.target.checked }))}
                  />
                  <span><strong>{c.label}</strong>{c.text}</span>
                </label>
              ))}
            </div>
          )}
        </div>
        <div className="cookie-actions">
          <button type="button" className="button button-dark" data-testid="cookie-accept"
            onClick={() => save({ preferences: true, analytics: true, marketing: true })}>Tout accepter</button>
          <button type="button" className="button button-outline" data-testid="cookie-reject"
            onClick={() => save({ preferences: false, analytics: false, marketing: false })}>Refuser l'optionnel</button>
          {manage
            ? <button type="button" className="cookie-link" data-testid="cookie-save" onClick={() => save(choice)}>Enregistrer mes choix</button>
            : <button type="button" className="cookie-link" data-testid="cookie-manage" onClick={() => setManage(true)}>Personnaliser</button>}
        </div>
      </div>
    </div>
  );
}
